/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_RedeemedInputs */

const en_us2_invite_redeemed = /** @type {(inputs: Invite_RedeemedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done: the invite was recorded.`)
};

const pt_br2_invite_redeemed = /** @type {(inputs: Invite_RedeemedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto: o convite foi registrado.`)
};

const pt_pt2_invite_redeemed = /** @type {(inputs: Invite_RedeemedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto: o convite foi registrado.`)
};

/** @type {(inputs: Invite_RedeemedInputs) => LocalizedString} */
const es_419_invite_redeemed = en_us2_invite_redeemed;

/** @type {(inputs: Invite_RedeemedInputs) => LocalizedString} */
const fr_fr2_invite_redeemed = en_us2_invite_redeemed;

/** @type {(inputs: Invite_RedeemedInputs) => LocalizedString} */
const de_de2_invite_redeemed = en_us2_invite_redeemed;

/** @type {(inputs: Invite_RedeemedInputs) => LocalizedString} */
const it_it2_invite_redeemed = en_us2_invite_redeemed;

/**
* | output |
* | --- |
* | "Done: the invite was recorded." |
*
* @param {Invite_RedeemedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_redeemed = /** @type {((inputs?: Invite_RedeemedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_RedeemedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_redeemed(inputs)
	if (locale === "es-419") return es_419_invite_redeemed(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_redeemed(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_redeemed(inputs)
	if (locale === "de-DE") return de_de2_invite_redeemed(inputs)
	if (locale === "it-IT") return it_it2_invite_redeemed(inputs)
	return en_us2_invite_redeemed(inputs)
});
export { invite_redeemed as "invite.redeemed" }